<template>
  <div>
    <Modal class="my-modal" v-model="visible" title="文章迁移" :mask-closable="false" :footer-hide="true" width="600px">
      <p class="title">将该分类下文章迁移至：</p>
      <Form ref="form" :model="formData" :label-width="40" class="formGauge">
        <FormItem class="flex" label="分类" prop="copywriting">
          <selectTreeOld :data="columnList" :multiple="false" :size="null" placeholder="请选择" :single="true"
            :showParentNode="true" :selectAllChildren="false" v-model="formData.newColumnId"></selectTreeOld>
          <span class="btn-add" @click="$emit('add')">新建分类</span>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="confirm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import selectTreeOld from '@/components/commons/selectTree';
export default {
  components: {
    selectTreeOld,
  },
  data() {
    return {
      visible: false,
      columnList:[],
      formData: {
        newColumnId:[]
      }
    }
  },
  methods: {
    open(id) {
      this.visible = true;
      this.$refs.form.resetFields();
      this.formData.oldColumnId = id;
      this.formData.newColumnId = [];
      this.getcmsColumn();
    },
    getcmsColumn() {
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: 'POST',
        data: {
          type: '1',
          pageNo: '1',
          pageSize: '999'
        }
      }).then(res => {
        this.columnList = this.dealTree(res.data);
      });
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },
    confirm() {
      if(!this.formData.newColumnId){
        return this.$notice.error('请选择要迁移的分类');
      }
      this.$http({
        url: '/buz/cmsColumn/moveColumnArticle',
        type: 'POST',
        data: {
          oldColumnId:this.formData.oldColumnId,
          newColumnId:this.formData.newColumnId[0],
        }
      }).then(res => {
        this.$notice.success('操作成功');
        this.visible = false;
        this.$emit('success')
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/.ivu-modal-body {
    padding: 0 20px 80px;
    overflow: unset;
  }

  .title {
    font-size: 13px;
    line-height: 18px;
    color: #3C464F;
    margin: 20px 0 14px;
  }

  .flex {
    display: flex;

    /deep/.ivu-form-item {
      margin-bottom: 10px;
    }

    /deep/.ivu-form-item-content {
      flex: 1;
      display: flex;
      /deep/.ivu-modal-wrap {
        flex: 1;
      }

      .ivu-select {
        flex: 1;
      }

      .btn-add {
        font-size: 13px;
        line-height: 34px;
        color: #236DFF;
        margin-left: 20px;
        cursor: pointer;
        margin-right: 10px;
        white-space: nowrap;
        flex: 1;
      }
    }
  }
}
</style>